import React, { useState } from 'react'
import {
    Box,
    Divider,
    Flex,
    Input,
    Text,
    FormControl,
    FormLabel,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    FormErrorMessage
} from '@chakra-ui/react'
import { MdAddCircle } from "react-icons/md";
import { GrEdit } from "react-icons/gr";
import { useEffect } from 'react';
import { Checkbox} from '@chakra-ui/react'



function AddOrderAddress() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [isShipping, setIsShipping] = useState(false)
    const [isBilling, setIsBilling] = useState(false)
    const [isOpen1, setIsOpen1] = useState(false)
    const onClose1 = () => setIsOpen1(false)
    const onOpen1 = () => setIsOpen1(true)
    const [errors, setErrors] = useState({})

    const shippingArea = JSON.parse(window.sessionStorage.getItem('shipping_Address_payload'))?.addressDetails
    const billingAddress = JSON.parse(window.sessionStorage.getItem('billing_Address_payload'))?.addressDetails

    const [billingData, setBillingData] = useState({
        firstName: billingAddress?.firstName || '',
        lastName: billingAddress?.lastName || '',
        phone: billingAddress?.phone || '',
        countryCode: billingAddress?.countryCode || '+91',
        city: billingAddress?.city || '',
        state: billingAddress?.state || '',
        district: billingAddress?.district || '',
        pincode: billingAddress?.pincode || '',
        country: billingAddress?.country || 'India',
        addressline1: billingAddress?.addressline1 || '',
        addressline2: billingAddress?.addressline2 || ''
    })

    const [shippingData, setShippingData] = useState({
        firstName: shippingArea?.firstName || "",
        lastName: shippingArea?.lastName || "",
        phone: shippingArea?.phone || "",
        countryCode: shippingArea?.countryCode || "+91",
        city: shippingArea?.city || "",
        state: shippingArea?.state || "",
        district: shippingArea?.district || "",
        pincode: shippingArea?.pincode || "",
        country: shippingArea?.country || "India",
        addressline1: shippingArea?.addressline1 || "",
        addressline2: shippingArea?.addressline2 || ""
    })

    const validations = (type,e) => {
        if(type === 'shipping'){
            const validationErrors = {}
        if((e.target.name === 'firstName' && (!e.target.value || e.target.value.length<2) ) || !shippingData.firstName){
            validationErrors.firstName = 'Please enter the first name'
        }
        if((e.target.name === 'lastName' && (!e.target.value || e.target.value.length<2)) || !shippingData.lastName){
            validationErrors.lastName = 'Please enter the last name'
        }
        if((e.target.name === 'phone' && (!e.target.value || e.target.value.length<2)) || !shippingData.phone.trim()){
            validationErrors.phone = 'Please enter 10 digit mobile number'
        }else if(e.target.name === "phone" && !/^[0-9]+$/.test(e.target.value)){
            validationErrors.phone = 'Must be only numbers'
        }else if(e.target.name === "phone" && e.target.value.length !== 10){
            validationErrors.phone= `Phone number must contain  ${10} digits`
        }
        if((e.target.name === 'district' && (!e.target.value || e.target.value.length<2)) ||!shippingData.district.trim()){
            validationErrors.district = 'Please enter the district name'
        }
        if((e.target.name === 'state' && (!e.target.value || e.target.value.length<2)) || !shippingData.state.trim()){
            validationErrors.state = 'Please enter the state name'
        }
        if( (e.target.name === 'pincode' && (!e.target.value || e.target.value.length<2)) || !shippingData.pincode.trim()){
            validationErrors.pincode = 'Please enter the 6 digit pincode'
        }else if(e.target.name === "pincode" && !/^[0-9]+$/.test(e.target.value)){
            validationErrors.pincode = 'Must be only numbers'
        } else if(e.target.name === "pincode" && e.target.value.length !== 6){
            validationErrors.pincode= `Pin code must contain  ${6} digits`
        }
        if((e.target.name === 'country' && (!e.target.value || e.target.value.length<2)) || !shippingData.country.trim()){
            validationErrors.country = 'Please enter the country name'
        }

        if( (e.target.name === 'addressline1' && (!e.target.value || e.target.value.length<2)) || !shippingData.addressline1.trim()){
            validationErrors.addressline1 = 'Please enter the complete address'
        }

        setErrors(validationErrors)
        }else{
            const validationErrors = {}
            if((e.target.name === 'firstName' && (!e.target.value || e.target.value.length<2) ) || !billingData.firstName){
                validationErrors.firstName = 'Please enter the first name'
            }
            if((e.target.name === 'lastName' && (!e.target.value || e.target.value.length<2)) || !billingData.lastName){
                validationErrors.lastName = 'Please enter the last name'
            }
            if((e.target.name === 'phone' && (!e.target.value || e.target.value.length<2)) || !billingData.phone.trim()){
                validationErrors.phone = 'Please enter 10 digit mobile number'
            }else if(e.target.name === "phone" && !/^[0-9]+$/.test(e.target.value)){
                validationErrors.phone = 'Must be only numbers'
            }else if(e.target.name === "phone" && e.target.value.length !== 10){
                validationErrors.phone= `Phone number must contain  ${10} digits`
            }
            if((e.target.name === 'district' && (!e.target.value || e.target.value.length<2)) ||!billingData.district.trim()){
                validationErrors.district = 'Please enter the district name'
            }
            if((e.target.name === 'state' && (!e.target.value || e.target.value.length<2)) || !billingData.state.trim()){
                validationErrors.state = 'Please enter the state name'
            }
            if( (e.target.name === 'pincode' && (!e.target.value || e.target.value.length<2)) || !billingData.pincode.trim()){
                validationErrors.pincode = 'Please enter the 6 digit pincode'
            }else if(e.target.name === "pincode" && !/^[0-9]+$/.test(e.target.value)){
                validationErrors.pincode = 'Must be only numbers'
            } else if(e.target.name === "pincode" && e.target.value.length !== 6){
                validationErrors.pincode= `Pin code must contain  ${6} digits`
            }
            if((e.target.name === 'country' && (!e.target.value || e.target.value.length<2)) || !billingData.country.trim()){
                validationErrors.country = 'Please enter the country name'
            }
    
            if( (e.target.name === 'addressline1' && (!e.target.value || e.target.value.length<2)) || !billingData.addressline1.trim()){
                validationErrors.addressline1 = 'Please enter the complete address'
            }
    
            setErrors(validationErrors)
        }        
    }


    const orderData = JSON.parse(window.sessionStorage.getItem('order_summary'))

    const handleChange = (e, type) => {
        if(type === 'shipping'){
            setShippingData({ ...shippingData, [e.target.name]: `${e.target.value}` })
            validations('shipping', e)
        }else{
            setBillingData({ ...billingData, [e.target.name]: `${e.target.value}` })
            validations('billing',e)

        }
    }

    const importAddress = (e) => {
       
        if (shippingData && shippingData !== null && e.target.checked) {
          setBillingData({ ...shippingData});
        }
        if(!e.target.checked){
            setBillingData({
              firstName: "",
              lastName: "",
              phone: "",
              countryCode:"+91",
              city: "",
              state: "",
              district:  "",
              pincode: "",
              country: "India",
              addressline1:  "",
              addressline2: "",
            });
        }
    }

    const handleSubmit = (e, type) => {
        e.preventDefault();
        if (type === 'shipping') {
            const validationErrors = {}
            if(!shippingData.firstName.trim()){
                validationErrors.firstName = 'Please enter the first name'
            }
            if(!shippingData.lastName.trim()){
                validationErrors.lastName = 'Please enter the last name'
            }
            if(!shippingData.phone.trim()){
                validationErrors.phone = 'Please enter 10 digit mobile number'
            }else if( !/^[0-9]+$/.test(shippingData.phone)){
                validationErrors.phone = 'Must be only numbers'
            }else if(shippingData.phone.length !== 10){
                validationErrors.phone= `Phone number must contain  ${10} digits`
            }
            if(!shippingData.district.trim()){
                validationErrors.district = 'Please enter the district name'
            }
            if(!shippingData.state.trim()){
                validationErrors.state = 'Please enter the state name'
            }
            if(!shippingData.pincode.trim()){
                validationErrors.pincode = 'Please enter the 6 digit pincode'
            }else if(!/^[0-9]+$/.test(shippingData.pincode)){
                validationErrors.pincode = 'Must be only numbers'
            } else if(shippingData.pincode.length !== 6){
                validationErrors.pincode= `Pin code must contain  ${6} digits`
            }
            if(!shippingData.country.trim()){
                validationErrors.country = 'Please enter the country name'
            }
    
            if(!shippingData.addressline1.trim()){
                validationErrors.addressline1 = 'Please enter the complete address'
            }
    
            setErrors(validationErrors)
           if(Object.keys(validationErrors).length === 0){
            let shippingData1 = JSON.stringify({
                "partyId": `${orderData.customerPartyId}`,
                "addressDetails": {
                    "firstName": `${shippingData.firstName}`,
                    "lastName": `${shippingData.lastName}`,
                    "phone": `${shippingData.phone}`,
                    "addressTypeEnumId": "PARTY_ADDRESS",
                    "addressline1": `${shippingData.addressline1}`,
                    "addressline2": `${shippingData.addressline2}`,
                    "city": `${shippingData.city}`,
                    "state": `${shippingData.state}`,
                    "district": `${shippingData.district}`,
                    "country": `${shippingData.country}`,
                    "countryCode": `${shippingData.countryCode}`,
                    "pincode": `${shippingData.pincode}`,
                    "partyId": `${orderData.customerPartyId}`
                }
            });
            window.sessionStorage.setItem('shipping_Address_payload', shippingData1)
            onClose()
            setIsShipping(true)
           }
        } else {
                const validationErrors = {}
                if(!billingData.firstName.trim()){
                    validationErrors.firstName = 'Please enter the first name'
                }
                if(!billingData.lastName.trim()){
                    validationErrors.lastName = 'Please enter the last name'
                }
                if(!billingData.phone.trim()){
                    validationErrors.phone = 'Please enter 10 digit mobile number'
                }else if( !/^[0-9]+$/.test(billingData.phone)){
                    validationErrors.phone = 'Must be only numbers'
                }else if(billingData.phone.length !== 10){
                    validationErrors.phone= `Phone number must contain  ${10} digits`
                }
                if(!billingData.district.trim()){
                    validationErrors.district = 'Please enter the district name'
                }
                if(!billingData.state.trim()){
                    validationErrors.state = 'Please enter the state name'
                }
                if(!billingData.pincode.trim()){
                    validationErrors.pincode = 'Please enter the 6 digit pincode'
                }else if(!/^[0-9]+$/.test(billingData.pincode)){
                    validationErrors.pincode = 'Must be only numbers'
                } else if(billingData.pincode.length !== 6){
                    validationErrors.pincode= `Pin code must contain  ${6} digits`
                }
                if(!billingData.country.trim()){
                    validationErrors.country = 'Please enter the country name'
                }
        
                if(!billingData.addressline1.trim()){
                    validationErrors.addressline1 = 'Please enter the complete address'
                }
        
                setErrors(validationErrors)
                if(Object.keys(validationErrors).length === 0){
                let billingData1 = JSON.stringify({
                    "partyId": `${orderData.customerPartyId}`,
                    "addressDetails": {
                        "firstName": `${billingData.firstName}`,
                        "lastName": `${billingData.lastName}`,
                        "phone": `${billingData.phone}`,
                        "addressTypeEnumId": "PARTY_ADDRESS",
                        "addressline1": `${billingData.addressline1}`,
                        "addressline2": `${billingData.addressline2}`,
                        "city": `${billingData.city}`,
                        "state": `${billingData.state}`,
                        "district": `${billingData.district}`,
                        "country": `${billingData.country}`,
                        "countryCode": `${billingData.countryCode}`,
                        "pincode": `${billingData.pincode}`,
                        "partyId": `${orderData.customerPartyId}`
                    }
                });
                window.sessionStorage.setItem('billing_Address_payload', billingData1)
                onClose1()
                setIsBilling(true)
            }
            
        }
     
    }


    useEffect(() => {
        if (JSON.parse(window.sessionStorage.getItem('shipping_Address_payload'))) {
            setIsShipping(true)
        } else {
            setIsShipping(false)
        }

        if (JSON.parse(window.sessionStorage.getItem('billing_Address_payload'))) {
            setIsBilling(true)
        } else {
            setIsBilling(false)
        }
    })


    return (
        <Box display={orderData.customerPartyId.length > 0 ? 'block' : 'none'} shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} p={4} my={5} bgColor={'rgba(255, 255, 255, 1)'} >
            <Text fontSize={'20px'} fontWeight={'semibold'}>Address</Text>
            <Flex w={'full'} justifyContent={'space-between'} flexDirection={'column'}>
                <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} pt={1} mt={3} >
                <Flex justifyContent={'center'} flexBasis={'48%'} rounded={'md'} alignItems={'center'} py={2} px={2} my={2} mx={2} bgColor={'#F1F6F9'} cursor={'pointer'} onClick={() => {
                    onOpen()
                    if (JSON.parse(window.sessionStorage.getItem('shipping_Address_payload'))) {
                        setIsShipping(true)
                    }
                }}>
                    {isShipping ?
                        <GrEdit color={'rgb(171,177,186)'} fontSize={'20px'} />
                        :
                        <MdAddCircle color={'rgb(171,177,186)'} fontSize={'26px'} />
                    }
                    <Text fontSize={'16px'} ml={2}>Shipping Address</Text>
                
                </Flex>

                {isShipping &&
                    <Box rounded={'md'} alignItems={'center'} py={1} px={2} my={1} mx={2} >
                        <Text fontSize={'sm'} fontWeight={'medium'}>First Name :- {shippingData?.firstName || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Last Name :- {shippingData?.lastName || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Address Line 1 :- {shippingData?.addressline1 || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Address Line 2 :- {shippingData?.addressline2 || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>City :- {shippingData?.city || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>State :- {shippingData?.state || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>District :- {shippingData?.district || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Country :- {shippingData?.countryCode || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Country :- {shippingData?.country || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Pin Code :- {shippingData?.pincode || '----'}</Text> 
                    </Box>
                    }
                </Box>

                <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} pt={1} mt={3}>
                <Flex justifyContent={'center'} flexBasis={'48%'} rounded={'md'} alignItems={'center'} py={2} px={2} my={2} mx={2} bgColor={'#F1F6F9'} cursor={'pointer'} onClick={() => {
                    onOpen1()
                    if (JSON.parse(window.sessionStorage.getItem('shipping_Address_payload'))) {
                        setIsShipping(true)
                    }
                }}>
                    {isBilling ?
                        <GrEdit color={'rgb(171,177,186)'} fontSize={'20px'} />
                        :
                        <MdAddCircle color={'rgb(171,177,186)'} fontSize={'26px'} />
                    }
                    <Text fontSize={'16px'} ml={2}>Billing Address</Text>
                    
                </Flex>

                {isBilling &&
                    <Box rounded={'md'} alignItems={'center'}  px={2}  mt={1}  py={1} my={1} mx={2}>
                        <Text fontSize={'sm'} fontWeight={'medium'}>First Name :- {billingData?.firstName || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Last Name :- {billingData?.lastName || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Address Line 1 :- {billingData?.addressline1 || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Address Line 2 :- {billingData?.addressline2 || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>City :- {billingData?.city || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>State :- {billingData?.state || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>District :- {billingData?.district || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Country :- {billingData?.countryCode || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Country :- {billingData?.country || '----'}</Text> 
                        <Text fontSize={'sm'} fontWeight={'medium'}>Pin Code :- {billingData?.pincode || '----'}</Text> 
                    </Box>
                    }
                </Box>
            </Flex>





            {/* ## Shipping Address Modal ## */}
            <Modal isOpen={isOpen} onClose={onClose} size={'6xl'}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={(e) => handleSubmit(e,'shipping')}>
                    <ModalHeader textAlign={'center'}>Add Shipping Address</ModalHeader>
                    <ModalCloseButton />
                    <Divider borderColor={'black'} />
                    <ModalBody>
                        <Flex width={'full'} justifyContent={'space-between'}>
                            <Box flexBasis={'48%'}>
                                <FormControl mt={4} isInvalid={errors?.firstName}>
                                    <FormLabel>First Name</FormLabel>
                                    <Input placeholder='Enter your first name' value={shippingData.firstName} onChange={(e) => handleChange(e, 'shipping')}  name='firstName' autoComplete="off" />
                                    {errors?.firstName &&(
                                         <FormErrorMessage>{errors.firstName}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.lastName}>
                                    <FormLabel>Last Name</FormLabel>
                                    <Input placeholder='Enter your last name' value={shippingData.lastName} onChange={(e) => handleChange(e, 'shipping')}  name='lastName' autoComplete="off" />
                                    {errors?.lastName &&(
                                         <FormErrorMessage>{errors.lastName}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.phone}>
                                    <FormLabel>Phone No.</FormLabel>
                                    <Input placeholder='Enter your contact no.' value={shippingData.phone} onChange={(e) => handleChange(e, 'shipping')}  name='phone' autoComplete="off" />
                                    {errors?.phone &&(
                                         <FormErrorMessage>{errors.phone}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.countryCode}>
                                    <FormLabel>Country Code</FormLabel>
                                    <Input placeholder='Enter your country code (for india - +91)' value={shippingData.countryCode} onChange={(e) => handleChange(e, 'shipping')}  name='countryCode' autoComplete="off" />
                                    {errors?.countryCode &&(
                                         <FormErrorMessage>{errors.countryCode}</FormErrorMessage>
                                    )}
                                </FormControl>
                            </Box>

                            <Box flexBasis={'48%'}>

                                <FormControl mt={4} isInvalid={errors?.city}>
                                    <FormLabel>City</FormLabel>
                                    <Input placeholder='Enter your city name' value={shippingData.city} onChange={(e) => handleChange(e, 'shipping')}  name='city' autoComplete="off" />
                                    {errors?.city &&(
                                         <FormErrorMessage>{errors.city}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.state}>
                                    <FormLabel>State</FormLabel>
                                    <Input placeholder='Enter your state name' value={shippingData.state} onChange={(e) => handleChange(e, 'shipping')}  name='state' autoComplete="off" />
                                    {errors?.state &&(
                                         <FormErrorMessage>{errors.state}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.district}>
                                    <FormLabel>District</FormLabel>
                                    <Input placeholder='Enter your district name' value={shippingData.district} onChange={(e) => handleChange(e, 'shipping')}  name='district' autoComplete="off" />
                                    {errors?.district &&(
                                         <FormErrorMessage>{errors.district}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.pincode}>
                                    <FormLabel>Pin Code</FormLabel>
                                    <Input placeholder='Enter your pin code' value={shippingData.pincode} onChange={(e) => handleChange(e, 'shipping')}  name='pincode' autoComplete="off" />
                                    {errors?.pincode &&(
                                         <FormErrorMessage>{errors.pincode}</FormErrorMessage>
                                    )}
                                </FormControl>

                            </Box>
                        </Flex>
                        <Box>
                            <FormControl mt={4} isInvalid={errors?.country}>
                                <FormLabel>Country</FormLabel>
                                <Input placeholder='Enter your country name' value={shippingData.country} onChange={(e) => handleChange(e, 'shipping')}  name='country' autoComplete="off" />
                                {errors?.country &&(
                                         <FormErrorMessage>{errors.country}</FormErrorMessage>
                                    )}
                            </FormControl>

                            <FormControl mt={4} isInvalid={errors?.addressline1}>
                                <FormLabel>Address Line 1</FormLabel>
                                <Input placeholder='Enter your address line 1' value={shippingData.addressline1} onChange={(e) => handleChange(e, 'shipping')}  name='addressline1' autoComplete="off" />
                                {errors?.addressline1 &&(
                                         <FormErrorMessage>{errors.addressline1}</FormErrorMessage>
                                    )}
                            </FormControl>

                            <FormControl mt={4} isInvalid={errors?.addressline2}>
                                <FormLabel>Address Line 2</FormLabel>
                                <Input placeholder='Enter your address line 2' value={shippingData.addressline2} onChange={(e) => handleChange(e, 'shipping')}  name='addressline2' autoComplete="off" />
                            </FormControl>
                        </Box>

                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='red' mr={3} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button colorScheme='whatsapp' mr={3} type='submit'>
                            {!isShipping ? 'Add' : 'Save Changes'}
                        </Button>
                    </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>

            {/* #### Billing Address Modal */}
            <Modal isOpen={isOpen1} onClose={onClose1} size={'6xl'}>
                <ModalOverlay />
                <ModalContent>
                 <form onSubmit={(e)=>handleSubmit(e,'billing')}>
                    <ModalHeader textAlign={'center'}>Add Billing Address</ModalHeader>
                    <ModalCloseButton />
                    <Divider borderColor={'black'} />
                   <Checkbox ml={"70%"} onChange={(e)=>importAddress(e)} > <Text fontSize={'16px'} fontWeight={'bold'}>Same as Shipping Address </Text></Checkbox>
                    <ModalBody>
                        <Flex width={'full'} justifyContent={'space-between'}>
                            <Box flexBasis={'48%'}>
                                <FormControl mt={4} isInvalid={errors.firstName}>
                                    <FormLabel>First Name</FormLabel>
                                    <Input placeholder='Enter your first name' value={billingData.firstName} onChange={(e) => handleChange(e, 'billing')}  name='firstName' autoComplete="off" />
                                    {errors?.firstName &&(
                                         <FormErrorMessage>{errors?.firstName}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.lastName}>
                                    <FormLabel>Last Name</FormLabel>
                                    <Input placeholder='Enter your last name' value={billingData.lastName} onChange={(e) => handleChange(e, 'billing')}  name='lastName' autoComplete="off" />
                                    {errors?.lastName &&(
                                         <FormErrorMessage>{errors.lastName}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.phone}>
                                    <FormLabel>Phone No.</FormLabel>
                                    <Input placeholder='Enter your contact no.' value={billingData.phone} onChange={(e) => handleChange(e, 'billing')}  name='phone' autoComplete="off" />
                                    {errors?.phone &&(
                                         <FormErrorMessage>{errors.phone}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.countryCode}>
                                    <FormLabel>Country Code</FormLabel>
                                    <Input placeholder='Enter your country code (for india - +91)' value={billingData.countryCode} onChange={(e) => handleChange(e, 'billing')}  name='countryCode' autoComplete="off" />
                                </FormControl>
                            </Box>

                            <Box flexBasis={'48%'}>

                                <FormControl mt={4} isInvalid={errors?.city}>
                                    <FormLabel>City</FormLabel>
                                    <Input placeholder='Enter your city name' value={billingData.city} onChange={(e) => handleChange(e, 'billing')}  name='city' autoComplete="off" />
                                    {errors?.city &&(
                                         <FormErrorMessage>{errors.city}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.state}>
                                    <FormLabel>State</FormLabel>
                                    <Input placeholder='Enter your state name' value={billingData.state} onChange={(e) => handleChange(e, 'billing')}  name='state' autoComplete="off" />
                                    {errors?.state &&(
                                         <FormErrorMessage>{errors.state}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.district}>
                                    <FormLabel>District</FormLabel>
                                    <Input placeholder='Enter your district name' value={billingData.district} onChange={(e) => handleChange(e, 'billing')}  name='district' autoComplete="off" />
                                    {errors?.district &&(
                                         <FormErrorMessage>{errors.district}</FormErrorMessage>
                                    )}
                                </FormControl>

                                <FormControl mt={4} isInvalid={errors?.pincode}>
                                    <FormLabel>Pin Code</FormLabel>
                                    <Input placeholder='Enter your pin code' value={billingData.pincode} onChange={(e) => handleChange(e, 'billing')}  name='pincode' autoComplete="off" />
                                    {errors?.pincode &&(
                                         <FormErrorMessage>{errors.pincode}</FormErrorMessage>
                                    )}
                                </FormControl>

                            </Box>
                        </Flex>
                        <Box>
                            <FormControl mt={4} isInvalid={errors?.country} >
                                <FormLabel>Country</FormLabel>
                                <Input placeholder='Enter your country name' value={billingData.country} onChange={(e) => handleChange(e, 'billing')}  name='country' autoComplete="off" />
                                {errors?.country &&(
                                         <FormErrorMessage>{errors.country}</FormErrorMessage>
                                    )}
                            </FormControl>

                            <FormControl mt={4} isInvalid={errors?.addressline1}>
                                <FormLabel>Address Line 1</FormLabel>
                                <Input placeholder='Enter your address line 1' value={billingData.addressline1} onChange={(e) => handleChange(e, 'billing')}  name='addressline1' autoComplete="off" />
                                {errors?.addressline1 &&(
                                         <FormErrorMessage>{errors.addressline1}</FormErrorMessage>
                                    )}
                            </FormControl>

                            <FormControl mt={4} isInvalid={errors?.addressline2}>
                                <FormLabel>Address Line 2</FormLabel>
                                <Input placeholder='Enter your address line 2' value={billingData.addressline2} onChange={(e) => handleChange(e, 'billing')}  name='addressline2' autoComplete="off" />
                            </FormControl>
                        </Box>

                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='red' mr={3} onClick={onClose1}>
                            Cancel
                        </Button>
                        <Button colorScheme='whatsapp' mr={3} type='submit'>
                            {!isBilling ? 'Add' : 'Save Changes'}
                        </Button>
                    </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
        </Box>

    )
}

export default AddOrderAddress